import { render, staticRenderFns } from "./EmailField.vue?vue&type=template&id=4f485ea7&scoped=true&"
import script from "./EmailField.vue?vue&type=script&lang=js&"
export * from "./EmailField.vue?vue&type=script&lang=js&"
import style0 from "./EmailField.vue?vue&type=style&index=0&id=4f485ea7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f485ea7",
  null
  
)

export default component.exports